import { OverlaySpinner } from '@insurancemenu/imenu-components-lib/dist/components/loaders';
import React from 'react';
import { SpinnerWrapperStyled } from './styles';

interface Props {
  height?: string;
}

export const SpinnerPlaceholder: React.FC<Props> = ({ height }) => {
  return (
    <SpinnerWrapperStyled $height={height}>
      <OverlaySpinner display />
    </SpinnerWrapperStyled>
  );
};
